import React from 'react';
import { Grid, TextField } from '@mui/material';
import { ICampoIndiceProps } from './ICampoIndiceProps';

export const CampoIntervaloAlfabetico: React.FC<ICampoIndiceProps> = ({ indice, valor, disabled, onChange, onEnterKeyDown }) => {
    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            onEnterKeyDown?.();
            e.preventDefault();
        }
    };

    return (
        <>
            <Grid item xs={6} sm={6} md={2} key={'menor-' + indice.idIndice}>
                <TextField
                    key={'RangeLetraMenor-' + indice.idIndice}
                    inputProps={{ pattern: '[A-Z]*', min: 0, style: { textTransform: 'uppercase' } }}
                    fullWidth
                    label={indice.nomeIndice + ' INICIAL'}
                    placeholder={`Digite o ${indice.nomeIndice} INICIAL`}
                    disabled={disabled}
                    value={valor?.split(' - ')[0] ?? ''}
                    onChange={(event) => {
                        let novoValor: string;
                        if (valor === undefined) {
                            novoValor = event.target.value + ' - ';
                        } else if (valor.charAt(0) === '-') {
                            novoValor = event.target.value + ' ' + valor;
                        } else {
                            novoValor = event.target.value + ' - ' + valor?.split(' - ')[1];
                        }
                        onChange(novoValor);
                    }}
                />
            </Grid>
            <Grid item xs={6} sm={6} md={2} key={'maior-' + indice.idIndice}>
                <TextField
                    key={'RangeLetraMaior-' + indice.idIndice}
                    inputProps={{ pattern: '[A-Z]*', min: 0, style: { textTransform: 'uppercase' } }}
                    fullWidth
                    label={indice.nomeIndice + ' FINAL'}
                    placeholder={`Digite o ${indice.nomeIndice} FINAL`}
                    disabled={disabled}
                    value={valor?.split(' - ')[1] ?? ''}
                    onKeyDown={handleKeyDown}
                    onChange={(event) => {
                        let novoValor: string;
                        if (valor === undefined || valor.charAt(0) === '-') {
                            novoValor = '- ' + event.target.value;
                        } else {
                            novoValor = valor?.split(' - ')[0] + ' - ' + event.target.value;
                        }
                        onChange(novoValor);
                    }}
                />
            </Grid>
        </>
    );
};
